import { CardCategory } from 'src/components/InforCard/InfoCard.types'

export const NoticeCategory: Record<string, CardCategory> = {
  estágio: {
    key: 'internship',
    label: 'Estágio',
    backgroundColor: '#EFF1FF',
    badgeBackground: '#D1D9FF',
    badgeTextColor: '#3F3D87',
    titleColor: '#111111'
  },
  bolsa: {
    key: 'scholarship',
    label: 'Bolsa',
    backgroundColor: '#EFF1FF',
    badgeBackground: '#C6E2FF',
    badgeTextColor: '#1658BC',
    titleColor: '#111111'
  },
  clt: {
    key: 'clt',
    label: 'CLT',
    backgroundColor: '#EFF1FF',
    badgeBackground: '#D1EDE4',
    badgeTextColor: '#2D6C03',
    titleColor: '#111111'
  }
}
export const getNoticeCategory = (key?: string): CardCategory => {
  if (!key) {
    return NoticeCategory.estágio
  }
  const formattedKey = key.trim().toLowerCase()
  return NoticeCategory[formattedKey] || NoticeCategory.estágio
}
